import resolutionHistory from "./resolutionHistory";
import targetedUsers from "./targetedUsers";
import incidents from "./incidents";
import incidentSummary from "./incidentSummary";
import linkLock from "./linkLock";
import notifications from "./notifications";
import exploitedDomains from "./exploitedDomains";
import antiSpoofing from "./antiSpoofing";
import graymail from "./graymail";

export default {
  incidents,
  incidentSummary,
  resolutionHistory,
  targetedUsers,
  linkLock,
  notifications,
  exploitedDomains,
  antiSpoofing,
  graymail,
};
